import React from 'react';
import { useTranslation } from 'react-i18next';
import SettingsNavigation from './SettingsAppearance';

const MeunSideSetting = ({ activeMenu, setActiveMenu }) => {
    const [t] = useTranslation('global');
    const items = [
        { id: 'MyAccount', label: 'حسابي' },
        { id: 'GeneralSettings', label: t('setting.generalSettings') },
        { id: 'MyCompany', label: t('setting.companySettings') },
        { id: 'MyBranches', label: t('setting.branchSettings') },
        { id: 'ChangePassword', label: 'تغيير كلمة المرور' },
        { id: 'InvoiceSettings', label: t('setting.invoiceSettings') },
        { id: 'QuoteSettings', label: t('setting.quoteSettings') },
        { id: 'PaymentMethod', label: t('setting.paymentMethodSettings') },
    ];
    return <SettingsNavigation items={items} activeMenu={activeMenu} onSelect={item => setActiveMenu(item.id)} label={t('setting.System_Settings')} />;
};
export default MeunSideSetting;
